export default __webpack_public_path__ + "static/media/b-6.07f1f75a.jpg";